import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

import { DynamicComponentsModule } from '@shared/components/dynamic-components/dynamic-components.module';

import { LoginComponent } from '../routes/login/login.component';
import { PasswordChangeComponent } from '../routes/password-change/password-change.component';
import { PlaygroundRegisterComponent } from '../routes/playground-register/playground-register.component';
import { RegisterComponent } from '../routes/register/register.component';
import { VersionComponent } from '../routes/version/version.component';
import { LayoutDefaultComponent } from './default/default.component';
import { NotificationComponent } from './default/sidebar/notification/notification.component';
import { SidebarComponent } from './default/sidebar/sidebar.component';
import { FullscreenComponent } from './fullscreen/fullscreen.component';

const COMPONENTS = [
  LayoutDefaultComponent,
  SidebarComponent,
  NotificationComponent,
  FullscreenComponent,
  LoginComponent,
  PasswordChangeComponent,
  RegisterComponent,
  VersionComponent,
  PlaygroundRegisterComponent
];

@NgModule({
  imports: [
    SharedModule,
    DynamicComponentsModule
  ],
  declarations: [
    ...COMPONENTS,
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class LayoutModule { }
